import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, CardHeader, createTheme, Typography, useMediaQuery } from "@mui/material"; // Import MUI components
import './slider.css'; // Import your CSS file
import image1 from "../../assets/empower.png";
import image2 from "../../assets//optmiza.png";
import image3 from "../../assets/accelerate.png";
import sol from '../../assets/innovationsolution.png';
const SliderBenifit = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
    });
    const isXsScreen = useMediaQuery((theme) => {
        console.log(theme); // Check if theme is null
        return theme?.breakpoints?.down('xs') || '(max-width: 575.98px)';
    });
    // Array of cards with background images and content
    const cards = [
        { id: 1, header: "Empower", content: "Enabling your business to reach new heights with tailored, user-friendly software solutions.", imageUrl: sol },
        { id: 2, header: "Optimize", content: "Maximizing efficiency and minimizing risks with state-of-the-art software and IT services.", imageUrl: image2 },
        { id: 3, header: "Accelerate", content: "Fueling your business growth with fast, secure, and scalable IT services.", imageUrl: image3 },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === cards.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, [cards.length]);
    if (isXsScreen) {
        return null; // Hide slider on extra-small screens
    }

    return (
        <Box
            className="slider-container"
            sx={{
                width: "100%", // Ensure it uses full width of the grid item

                maxWidth: {
                    xs: "280px",
                    sm: "100%",
                    md: "100%",
                    lg: "100%",
                    xl: "100%"
                },
                // Set a max width if needed
                height: "300px",
                overflow: "hidden",
                margin: "0",
                marginLeft:"10px",
                borderRadius: "30px",
                borderTopRightRadius: "100px",
                borderTopLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                borderBottomLeftRadius: "20px",
                // marginTop: "32px",
            }}
        >
            <Box
                className="slider-wrapper"
                sx={{
                    display: "flex",
                    transition: "transform 0.5s ease-in-out",
                    height: "300px",
                    transform: `translateX(-${currentIndex * 100}%)`,

                }}
            >
                {cards.map((card) => (
                    <Card
                        key={card.id}
                        sx={{
                            minWidth: "100%",
                            // height: "100%",
                            backgroundColor: "#0B77A8",
                            color: "white",
                            // height: "300px",
                            overflow: "hidden",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",

                        }}
                    >
                        <CardHeader style={{ display: "grid" }}
                            avatar={
                                <Box component='img' src={card.imageUrl} style={{ width: '50px', height: '50px', marginBottom: "10px" }} />
                            }
                            title={<Typography variant="h5" className='poppins-bold' >  {card.header}</Typography>}
                        />
                        <CardContent sx={{
                            // width: {
                            //     lg: "50%",
                            //     md: "100%"
                            // }
                        }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: {
                                        xs: "1.2rem",  // For extra small screens
                                        sm: "0.9rem",   // For small screens
                                        md: "1rem",     // For medium screens
                                        lg: "1.2rem"    // For large screens
                                    }
                                }}
                                className='poppins-semibold'
                            >
                                {card.content}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default SliderBenifit;

